import { getResourceEvents } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export function useGetEventsForResource({
  resourceId,
}: {
  resourceId: string;
}) {
  return useQuery(['get-resource-events', resourceId], () =>
    getResourceEvents(resourceId)
  );
}
